import { useState } from "react";
import { Link } from "react-router-dom";

import { CardLink, PageHeader } from "../components/kit";
import { V3Title, V3Actions, V3_PRIMARY } from "../components/v3";
import { ResultTable, ResultRow, V3_LINK } from "../components/v3app";
import { Blocked } from "../components/v3plans";
import { MEMBER_NAV, PERSONAL_NAV } from "../components/MemberLayout";

const FAQ = [
  ["Wie finde ich Menschen?", "Unter „Menschen“ kannst du nach Stadt, Interessen und Sprachen filtern. Zuerst sendest du eine Kontaktanfrage; Nachrichten sind erst nach der Annahme möglich."],
  ["Was bedeuten „Anfrage offen“ und „Bestätigt“?", "Bei Aktivitäten mit Bestätigung steht deine Teilnahme zuerst auf „Anfrage offen“. „Bestätigt“ heisst, dass du eingetragen bist. Gemerkte Aktivitäten sind keine Teilnahme."],
  ["Wer sieht meinen Access Pass?", "Nur du. Er wird nie automatisch geteilt – auch nicht durch Kontakte, Kreise oder Teilnahmen."],
  ["Wie ändere ich Schriftgrösse und Kontrast?", "Unter „Einstellungen“ → „Darstellung“. Schon vor der Anmeldung über das Symbol oben auf der Anmeldeseite."],
  ["Was tun bei Problemen mit einer Person?", "Du kannst die Person blockieren und – getrennt davon – melden. Beides findest du im Profil der Person und bei jeder fremden Nachricht."],
];

const Panel = ({ testid, children }) => <div className="mt-[6px] space-y-[8px] rounded-[10px] bg-v3-lilac px-[16px] py-[12px] text-[14.5px] leading-[21px] text-v3-ink" data-testid={testid}>{children}</div>;

const ROWS = [
  { key: "guide", title: "Bedienung verstehen", context: "Schrittweise Anleitung öffnen", body: (
    <div className="space-y-[6px]">{FAQ.map(([q, a]) => (
      <details key={q} className="rounded-[8px] border border-v3-line bg-white px-[12px] py-[8px]">
        <summary className="min-h-[32px] cursor-pointer font-bold">{q}</summary><p className="mt-[6px] text-v3-muted">{a}</p>
      </details>))}</div>) },
  { key: "activity", title: "Frage zur Aktivität", context: "Zuständige Gastgeberin kontaktieren", body: (<>
    <p>Öffne die Aktivität und wähle „Frage zum Zugang stellen“. Fragen an Gastgebende sind im gemeinsamen Core noch nicht eingerichtet und werden noch nicht gesendet.</p>
    <Link to="/plaene/liste" data-testid="help-activity-plans" className={V3_LINK}>Zu meinen Plänen</Link>
  </>) },
  { key: "report", title: "Inhalt melden", context: "Nur den ausgewählten Kontext übermitteln", body: (<>
    <p>Melden geht direkt bei einer Nachricht, einem Beitrag oder im Profil einer Person. Vor dem Senden siehst du, was übermittelt wird.</p>
    <Link to="/hilfe/moderation" data-testid="help-report-moderation" className={V3_LINK}>Meine Meldungen und Entscheidungen</Link>
  </>) },
  { key: "support", title: "VISIBILIS kontaktieren", context: "Eigene Supportanfrage verfassen", body: (
    <p>Eine Supportanfrage mit Statusanzeige direkt aus der App ist noch nicht verfügbar. Es wird nichts gesendet.</p>) },
];

// M28: help paths; support requests need POST /member/support-requests (D-91), so the primary action stays locked.
export function Help() {
  const [open, setOpen] = useState("");
  return (
    <div data-m="M28" data-testid="help-page">
      <V3Title title="Hilfe, Melden und Supportkontakt" intro="Wähle den passenden Hilfeweg für dein Anliegen." testid="help-title" />
      <ResultTable testid="help-list" label="Hilfewege">
        {ROWS.map((r) => (
          <ResultRow key={r.key} initial="V" title={r.title} context={r.context} onOpen={() => setOpen((v) => (v === r.key ? "" : r.key))} expanded={open === r.key} testid={`help-${r.key}`}>
            {open === r.key && <Panel testid={`help-${r.key}-panel`}>{r.body}</Panel>}
          </ResultRow>
        ))}
      </ResultTable>
      <Blocked id="help-support-blocked">Supportanfragen sind im gemeinsamen Core noch nicht eingerichtet. Es wird nichts gesendet.</Blocked>
      <V3Actions>
        <button type="button" disabled aria-describedby="help-support-blocked" data-testid="help-support-compose" className={V3_PRIMARY}>Supportanfrage verfassen</button>
      </V3Actions>
    </div>
  );
}

// Mobile overview of all areas ("Mehr").
export function More() {
  return (
    <div>
      <PageHeader title="Alle Bereiche" />
      <div className="grid gap-3 sm:grid-cols-2" data-testid="more-grid">
        {[...MEMBER_NAV, ...PERSONAL_NAV].map((i) => <CardLink key={i.key} to={i.path} icon={i.icon} title={i.label} testid={`more-${i.key}`} />)}
      </div>
    </div>
  );
}
